import { useEffect, useState } from "react";
import { useAudioRecorder } from "../hooks/use-audio-recorder";

const AudioRecorder = () => {
  const { isRecording, startRecording, stopRecording, audioBlob } = useAudioRecorder();
  const [audioUrl, setAudioUrl] = useState<string | null>(null);

  useEffect(() => {
    if (audioBlob) {
      setAudioUrl(URL.createObjectURL(audioBlob));
    }
  }, [audioBlob]);

  return (
    <div>
      <button 
          className={`record-button ${isRecording ? "active" : ""}`} onClick={startRecording} disabled={isRecording}>
        🎤 Iniciar Gravação
      </button>
      <button 
          className="stop-button" onClick={stopRecording} disabled={!isRecording}>
        ⏹️ Parar Gravação
      </button>

      {audioUrl && (
        <div>
          <h4>Prévia do Áudio Gravado:</h4>
          <audio controls src={audioUrl}></audio>
          <p><a href={audioUrl} download="audio.wav" style={{color: 'white'}}>📥 Baixar Áudio</a></p>
        </div>
      )}
    </div>
  );
};

export default AudioRecorder;